import React from "react"
import { Sidebar } from './sidebar'
import { Header } from './header'

interface DashboardLayoutProps {
  children: React.ReactNode
  title: string
  subtitle?: string
  actions?: React.ReactNode
}

export function DashboardLayout({ children, title, subtitle, actions }: DashboardLayoutProps) {
  return (
    <div className="flex">
      <Sidebar />
      <div className="flex-1 ml-56">
        <Header title={title} subtitle={subtitle} actions={actions} />
        <main className="pt-20 pb-8 px-8 bg-background min-h-screen">
          {children}
        </main>
      </div>
    </div>
  )
}
